module.exports = "<app-poi-edit-template on-cancel=$ctrl.cancel() on-save=$ctrl.save() poi=$ctrl.poi switch-tab-prefix=app.poicreate> </app-poi-edit-template> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/create/partial.html
// module id = 425
// module chunks = 0